import { BaseQueryFn, EndpointBuilder, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { Promotion, ResponsePromotionDto } from '../types/dtos';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<Promotion, string>({
        async queryFn(promotionId, _queryApi, _extraOptions, fetchWithBQ) {
            const promotionResult = await fetchWithBQ(`${APP_ENDPOINTS.PROMOTION}/${promotionId}`);

            if (promotionResult.error) return { error: promotionResult.error as FetchBaseQueryError };

            const promotion = promotionResult.data as ResponsePromotionDto;

            return {
                data: promotion,
            };
        },
        providesTags: [{ type: 'promotion', id: 'GET-ID' }],
    });
